// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__Af_3r","selects":"Documents_selects__g91G3"};